<template>
	<svg
		width="38"
		height="40"
		viewBox="0 0 38 40"
		fill="white"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g opacity="0.8">
			<path
				d="M19 5.92603C12.0563 5.92603 6.40739 11.5749 6.40739 18.5186C6.40739 23.7868 9.65999 28.4534 14.5555 30.2964V37.0371C14.5555 37.4468 14.8867 37.7779 15.2963 37.7779H16.037V39.2594C16.037 39.669 16.3681 40.0001 16.7778 40.0001H21.2222C21.6318 40.0001 21.9629 39.669 21.9629 39.2594V37.7779H22.7037C23.1133 37.7779 23.4444 37.4468 23.4444 37.0371V30.2964C28.34 28.4534 31.5926 23.7868 31.5926 18.5186C31.5926 11.5749 25.9437 5.92603 19 5.92603ZM21.2222 36.2964C20.8126 36.2964 20.4815 36.6275 20.4815 37.0371V38.5186H17.5185V37.0371C17.5185 36.6275 17.1874 36.2964 16.7778 36.2964H16.037V32.5927H21.9629V36.2964H21.2222ZM22.4726 29.0682C22.1681 29.1682 21.9629 29.4527 21.9629 29.772V31.1112H16.037V29.772C16.037 29.452 15.8318 29.1682 15.5274 29.0682C10.9592 27.566 7.88888 23.326 7.88888 18.5186C7.88888 12.392 12.8733 7.40751 19 7.40751C25.1267 7.40751 30.1111 12.392 30.1111 18.5186C30.1111 23.326 27.0407 27.566 22.4726 29.0682Z"
			/>
			<path
				d="M19 4.44444C19.4096 4.44444 19.7408 4.11333 19.7408 3.7037V0.740741C19.7408 0.331111 19.4096 0 19 0C18.5904 0 18.2593 0.331111 18.2593 0.740741V3.7037C18.2593 4.11333 18.5904 4.44444 19 4.44444Z"
			/>
			<path
				d="M36.7778 17.7778H33.8148C33.4052 17.7778 33.0741 18.1089 33.0741 18.5186C33.0741 18.9282 33.4052 19.2593 33.8148 19.2593H36.7778C37.1874 19.2593 37.5185 18.9282 37.5185 18.5186C37.5185 18.1089 37.1874 17.7778 36.7778 17.7778Z"
			/>
			<path
				d="M4.18519 17.7778H1.22222C0.812595 17.7778 0.481483 18.1089 0.481483 18.5186C0.481483 18.9282 0.812595 19.2593 1.22222 19.2593H4.18519C4.59482 19.2593 4.92593 18.9282 4.92593 18.5186C4.92593 18.1089 4.59482 17.7778 4.18519 17.7778Z"
			/>
			<path
				d="M31.0474 5.42373L28.9526 7.51855C28.663 7.80818 28.663 8.27632 28.9526 8.56595C29.0971 8.7104 29.2867 8.78299 29.4763 8.78299C29.6659 8.78299 29.8556 8.7104 30 8.56595L32.0948 6.47114C32.3845 6.18151 32.3845 5.71336 32.0948 5.42373C31.8052 5.1341 31.3363 5.13484 31.0474 5.42373Z"
			/>
			<path
				d="M7.99999 28.4711L5.90518 30.5659C5.61555 30.8556 5.61555 31.3237 5.90518 31.6134C6.04962 31.7578 6.23925 31.8304 6.42888 31.8304C6.61851 31.8304 6.80814 31.7578 6.95259 31.6134L9.0474 29.5185C9.33703 29.2289 9.33703 28.7608 9.0474 28.4711C8.75777 28.1815 8.28962 28.1815 7.99999 28.4711Z"
			/>
			<path
				d="M30 28.4711C29.7104 28.1815 29.2422 28.1815 28.9526 28.4711C28.663 28.7608 28.663 29.2289 28.9526 29.5185L31.0474 31.6134C31.1919 31.7578 31.3815 31.8304 31.5711 31.8304C31.7607 31.8304 31.9504 31.7578 32.0948 31.6134C32.3844 31.3237 32.3844 30.8556 32.0948 30.5659L30 28.4711Z"
			/>
			<path
				d="M8.00003 8.56599C8.14448 8.71043 8.33411 8.78303 8.52374 8.78303C8.71337 8.78303 8.90299 8.71043 9.04744 8.56599C9.33707 8.27636 9.33707 7.80821 9.04744 7.51858L6.95263 5.42377C6.663 5.13414 6.19485 5.13414 5.90522 5.42377C5.61559 5.71339 5.61559 6.18154 5.90522 6.47117L8.00003 8.56599Z"
			/>
			<path
				d="M19 9.62964C14.0985 9.62964 10.1111 13.617 10.1111 18.5185C10.1111 18.9282 10.4422 19.2593 10.8518 19.2593C11.2615 19.2593 11.5926 18.9282 11.5926 18.5185C11.5926 14.4341 14.9155 11.1111 19 11.1111C19.4096 11.1111 19.7407 10.78 19.7407 10.3704C19.7407 9.96075 19.4096 9.62964 19 9.62964Z"
			/>
		</g>
	</svg>
</template>
<script>
export default {
	name: 'IconLamp',
}
</script>
